export default "/imgs/tag/falsifications.svg"